import React from 'react'
import { useNavigate } from 'react-router-dom';

export default function Datalist({ data }) {

    const navigation = useNavigate();

    if (!data) {
        return (
            <div className="flex items-center justify-center min-h-[200px] text-gray-500">
                กำลังโหลดข้อมูล...
            </div>
        )
    }

    return (
        <div className="container mx-auto px-4">
            <div className={`
            grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4
            ${data.length < 3 ? 'place-items-center' : ''}
        `}>
                {data.map((item) => (
                    <div
                        key={item.CUSTCODE}
                        className={`
                        bg-white bg-opacity-90 rounded-lg shadow-md p-6 
                        hover:shadow-lg transition-shadow duration-300
                        ${data.length === 1 ? 'md:col-span-2 lg:col-span-3' : ''}
                        ${data.length === 2 ? 'lg:col-span-2' : ''}
                        w-full max-w-xl
                    `}
                    >
                        {/* ส่วนหัว */}
                        <div className="mb-4">
                            <h3 className="text-lg font-semibold text-gray-800 truncate">
                                {item.FIRSTNAME}
                            </h3>
                            <p className="text-sm text-gray-500">
                                รหัสลูกค้า: {item.CUSTCODE}
                            </p>
                        </div>

                        {/* ข้อมูลคะแนน */}
                        <div className="space-y-3">
                            <div className="flex justify-between items-center">
                                <span className="text-gray-600">สิทธิ์ที่ได้รับทั้งหมด</span>
                                <span className="font-medium text-green-600">
                                    {item.TOTAL_POINT_RECEIVED} ครั้ง
                                </span>
                            </div>
                            <div className="flex justify-between items-center">
                                <span className="text-gray-600">ใช้ไปแล้ว</span>
                                <span className="font-medium text-orange-600">
                                    {item.TOTAL_POINT_USED} ครั้ง
                                </span>
                            </div>
                            <div className="pt-3 border-t">
                                <div className="flex justify-between items-center">
                                    <span className="font-medium">เหลือสิทธิ์เล่นอีก</span>
                                    <div className="text-center">
                                        <span className="font-bold text-2xl text-blue-600">
                                            {item.POINT_BALANCE}
                                        </span>
                                        <span className="ml-1 text-sm text-gray-600">ครั้ง</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ปุ่มดำเนินการ */}
                        <div className="mt-4">
                            <button
                                type="button"
                                onClick={() => {
                                    // console.log(item.CUSTCODE)
                                    navigation(`/wheel-game-play/${item.CUSTCODE}`)
                                }}
                                // disabled={parseInt(item.POINT_BALANCE) === 0 && parseInt(item.TOTAL_POINT_USED) === 0}
                                className={`
                                w-full py-2.5 px-4 rounded-lg font-medium text-white transition-all
                                ${parseInt(item.POINT_BALANCE) > 0
                                        ? 'bg-orange-500 hover:bg-orange-600 active:bg-orange-700 shadow-sm shadow-orange-950/10'
                                        : parseInt(item.TOTAL_POINT_USED) > 0
                                            ? 'bg-blue-500 hover:bg-blue-600 active:bg-blue-700 shadow-sm shadow-blue-950/10'
                                            : 'bg-gray-300 cursor-not-allowed'
                                    }
                            `}
                            // cursor-not-allowed
                            >
                                {parseInt(item.POINT_BALANCE) > 0
                                    ? 'เล่นเกมลุ้นรางวัล !!'
                                    : parseInt(item.TOTAL_POINT_USED) > 0
                                        ? 'ดูประวัติการเล่น'
                                        : 'ไม่มีสิทธิ์เล่นเหลือ'}
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}